var accessTypes = [
  { name: 'ثبت نام', value: 0, accessType: 0, nameEn: 'RegisterMember' },
  { name: 'ثبت استاد', value: 1, accessType: 1, nameEn: 'RegisterTeacher' },
  { name: 'ثبت نتیجه آزمون', value: 2, accessType: 2, nameEn: 'TestResult' },
  { name: 'صدور گواهی', value: 3, accessType: 3, nameEn: 'GenerateLicense' },
  { name: 'حضور و غیاب', value: 4, accessType: 4, nameEn: 'Absence ' },
  { name: 'ایجاد کلاس', value: 5, accessType: 5, nameEn: 'CreateClass ' },
  {
    name: 'گزارش پرداخت ها',
    accessType: 6,
    value: 6,
    nameEn: 'ReportPayments '
  },
  { name: 'چاپ گواهی', accessType: 7, value: 7, nameEn: 'PrintLicense ' },
  {
    name: 'رویت لیست شرکت کنندگان',
    accessType: 8,
    value: 8,
    nameEn: 'DisplayMembersList '
  }
]

export default accessTypes
